import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SurveyResultsFilterNames } from 'models';
import { IFilterChangePayload } from 'modules/admin-panel/pages/results/models';
import {
	getFromSessionStorage,
	SessionStorageKeyTypes,
} from 'utils/clientStorage';
import {
	calculatedRoundsSelector,
	statisticGroupingTypeSelector,
} from 'modules/admin-panel/pages/results/selectors/dashboard.selectors';
import { setActiveRound } from 'modules/admin-panel/pages/results/results.actions';
import { useSurveyResultsFilter } from '../useSurveyResultsFilter';

export const useSetActiveRound = () => {
	const dispatch = useDispatch();
	const {
		onChangeSurveyResultsFilter,
		surveyFilter,
	} = useSurveyResultsFilter();
	const surveyId = getFromSessionStorage(
		SessionStorageKeyTypes.dashboardSurveyId,
	);
	const rounds = useSelector(calculatedRoundsSelector);
	const groupingType = useSelector(statisticGroupingTypeSelector);

	const boundSetActiveRound = useCallback(
		(p: IFilterChangePayload) => dispatch(setActiveRound(p)),
		[dispatch],
	);

	return useCallback(
		(curRoundId?: string) => {
			boundSetActiveRound({
				rounds,
				surveyId,
				...surveyFilter,
				roundId: curRoundId || '',
				groupingType,
			});
			onChangeSurveyResultsFilter({
				[SurveyResultsFilterNames.roundId]: curRoundId,
			});
		},
		[
			boundSetActiveRound,
			surveyId,
			rounds,
			groupingType,
			onChangeSurveyResultsFilter,
			surveyFilter,
		],
	);
};
